/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import { call, put } from "redux-saga/effects";
import api from "../services/httpUtilities/httpService";
import httpErrorHelpers from "../services/httpUtilities/httpErrorHelpers";
import * as searchAction from "../actions/search";

function* watcherPostNewSearchRequest({ keyword }) {
  try {
    const response = yield call(api.postNewSearch, keyword);

    yield put(searchAction.postNewSearchSuccess(keyword, response.data));
  } catch (error) {
    yield call(httpErrorHelpers, error, searchAction.postNewSearchFailure);
  }
}

function* watcherPutSearchQueryTokenRequest({ query }) {
  try {
    const response = yield call(api.putSearchQuery, query);

    yield put(searchAction.putSearchQueryTokenSuccess());
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      searchAction.putSearchQueryTokenFailure,
      true
    );
  }
}

export { watcherPostNewSearchRequest, watcherPutSearchQueryTokenRequest };



// WEBPACK FOOTER //
// ./src/sagas/search.js